module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/166-morocco-f2376287dcc810f4a1d54d65e01102e0.svg";